export const PAGE_SETTINGS = 'PAGE_SETTINGS'
export const PAGE_CONTENT = 'PAGE_CONTENT'
export const COMMUNITY = 'COMMUNITY'
export const PRINCIPLES = 'PRINCIPLES'
export const PROJECTS = 'PROJECTS'
export const ABOUT = 'ABOUT'
export const GITHUB = 'GITHUB'
export const TRADEMARKS = 'TRADEMARKS'
export const FOOTER = 'FOOTER'
